import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <section className="mx-auto flex min-h-screen max-w-2xl flex-col justify-center gap-3 p-8">
      <h1 className="text-xl font-bold">페이지를 찾을 수 없습니다</h1>
      <Link to="/" className="text-sm underline">
        처음으로 돌아가기
      </Link>
    </section>
  );
}
